/**
 * Use IntersectionObserver to detect whether an element is sticky or not.
 */
( function () {
	const el = document.querySelector( '.sticky-element' );

	if ( ! el ) {
		return;
	}

	const observer = new IntersectionObserver(
		( [ event ] ) => event.target.classList.toggle( 'is-pinned', event.boundingClientRect.top < 0 && event.intersectionRect.top < 1 ), { threshold: [ 0, 0.5, 1 ] }
	);

	observer.observe( el );
} )();
